import { render } from "./trainning_institute_drawer.vue?vue&type=template&id=c61956cc&ts=true"
import script from "./trainning_institute_drawer.vue?vue&type=script&lang=ts"
export * from "./trainning_institute_drawer.vue?vue&type=script&lang=ts"

import "./trainning_institute_drawer.vue?vue&type=style&index=0&id=c61956cc&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__